(function () {
  var SCHEDULER_ID = 'schedule';

  function getScheduler() {
    var el = document.getElementById(SCHEDULER_ID);
    if (!el) return null;
    if (el.tagName === 'DETAILS') return el;
    return el.querySelector('details');
  }

  function openScheduler(opts) {
    var d = getScheduler();
    if (!d || d.tagName !== 'DETAILS') return;
    var o = opts || {};
    d.open = true;
    if (!o.skipScroll && typeof d.scrollIntoView === 'function') {
      requestAnimationFrame(function () {
        d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function onRemoteClick(e) {
    if (e.currentTarget.getAttribute('href') !== '#' + SCHEDULER_ID) return;
    e.preventDefault();
    openScheduler({});
  }

  function init() {
    document.querySelectorAll('a[href="#' + SCHEDULER_ID + '"]').forEach(function (a) {
      a.addEventListener('click', onRemoteClick);
    });

    if (window.location.hash === '#' + SCHEDULER_ID) {
      openScheduler({ skipScroll: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
